import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  deleteDon: {
    url: `${API_URL}/xoaDon/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonCu: {
    url: `${API_URL}/donCus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getNguonDon: {
    url: `${API_URL}/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: `${API_URL}/loaiDonThus?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    },
  },
  getHuongXuLy: {
    url: `${API_URL}/huongXuLys?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyDon: {
    url: `${API_URL}/huongXuLyXLDs/vaiTro?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  capCoQuanQuanLy: {
    url: `${API_URL}/capCoQuanQuanLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postXuLyDon: {
    url: `${API_URL}/xuLyDons`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateXuLyDonVanThu: {
    url: `${API_URL}/xuLyDons/:id`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  dinhChiDon: {
    url: `${API_URL}/xuLyDons/dinhChiDon?id=:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getThoiHanXuLy: {
    url: `${API_URL}/thoiHans?loaiThoiHan=THOIHAN_XULYDON&page=0&size=1000&sort=soNgay,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListXuLyDon: {
    url: `${API_URL}/danhSachXuLyDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getDonCusInfo: {
    url: `${API_URL}/donCus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanXuLy: {
    url: `${API_URL}/thongKes/danhSachDonTreHanXuLyTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanXuLyTaiDiaBan: {
    url: `${API_URL}/thongKes/danhSachDonTreHanXuLyTaiDiaBan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanGiaiQuyet: {
    url: `${API_URL}/thongKes/danhSachDonTreHanGiaiQuyetTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanGiaiQuyetTaiDiaBan: {
    url: `${API_URL}/thongKes/danhSachDonTreHanGiaiQuyetTaiDiaBan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getPhieuChuyenDonKNPA: {
    url: `${API_URL}/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuChuyenDonToCao: {
    url: `${API_URL}/xuLyDons/inPhieuChuyenDonToCao?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuDeXuatThuLy: {
    url: `${API_URL}/xuLyDons/inPhieuDeXuatThuLy?loaiDon=:loaiDon&ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuKhongDuDieuKienThuLyKN: {
    url: `${API_URL}/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&lyDoDinhChi=:lyDoDinhChi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuTraDonVaHuongDanKN: {
    url: `${API_URL}/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuyTrinhXuLyGiaoViec: {
    url: `${API_URL}/quyTrinhXuLyXLDs/giaoViec?vaiTro=CHUYEN_VIEN`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhongBan: {
    url: `${API_URL}/coQuanQuanLys?cha=:cha&notCha=false`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getCoQuanQLTPDN: {
    url: `${API_URL}/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getCoQuan: {
    url: `${API_URL}/coQuanQuanLys?page=0&size=1000&sort=ten,asc&capCoQuanQuanLy=:capCQID`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getCongChuc: {
    url: `${API_URL}/congChucs?coQuanQuanLyId=:coQuanQuanLyId`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCongChucVaiTro: {
    url: `${API_URL}/congChucs?vaiTro=:vaiTro&coQuanQuanLyId=:coQuanQuanLyId`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuyTrinhXuLy: {
    url: `${API_URL}/quyTrinhXuLyXLDs/giaoViec?vaiTro=:vaiTro`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getcoQuanQuanLyInfo: {
    url: `${API_URL}/coQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: `${API_URL}/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    },
  },
  getLoaiDoiTuong: {
    url: `${API_URL}/loaiDoiTuongs?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    },
  },
  getLoaiNguoiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    },
  },
  getphongBanXuLy: {
    url: `${API_URL}/coQuanQuanLys/phongBanGiaiQuyets`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    },
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/letterProcessing.js